import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { SalesCallsService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { SalesCalls } from '../../models'

const log = new Logger('SalesCallsDetailResolver')
@Injectable({ providedIn: 'root' })
export class SalesCallsDetailResolver
  implements Resolve<Observable<SalesCalls>> {
  constructor(
    private salescallsService: SalesCallsService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['sid']
    
    return this.salescallsService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/salescalls']))
    )
  }
}
